export default {
    init($) {
        // sect2 no parcelamento de cartoa de crédito

        let setupSelect2 = ()=>{
            let select = $('#pagarme-installments');
            if (select.length){
                select.select2();
            }
        };
        setupSelect2();

        $(document.body).on('updated_checkout', function () {
            setupSelect2();
        })
    }
}